export default "__VITE_ASSET__CGTAy0ku__"